// A 4px bar in shoot on line. `value` 0..1, or omit for indeterminate.
type Props = {value?: number; label?: string; className?: string};

export default function ProgressBar({value, label = 'Progress', className = ''}: Props) {
    const determinate = typeof value === 'number' && Number.isFinite(value);
    const pct = determinate ? Math.max(0, Math.min(1, value)) * 100 : 40;
    return (
        <div
            role="progressbar"
            aria-label={label}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={determinate ? Math.round(pct) : undefined}
            className={`relative h-1 w-full overflow-hidden rounded-pill bg-line ${className}`}
        >
            <div
                className={`absolute inset-y-0 left-0 rounded-pill bg-shoot ${determinate ? 'transition-[width] duration-200' : 'progress-indeterminate'}`}
                style={{width: `${pct}%`}}
            />
        </div>
    );
}
